// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"CurationDate__srOnly--2srPB","hiddenInput":"CurationDate__hiddenInput--2QYE9","root":"CurationDate__root--3g3wq"};